import React from 'react'

import { Flex } from 'stardust'
import styled from 'styled-components'

import { useChatAutoScroll } from '~/pages/Observations/useChatAutoScroll'
import colors from '~/ui-components/tokens/colors'

import Chat from './Chat'
import LoadingAIBubble from './LoadingAIBubble'

interface ConversationProps {
  messages: Playground.AssistantConversationMessage[]
  isFetching?: boolean
  maxHeight: string
  minHeight: string
  isLog?: boolean
  handleAssistActionPill?: (action: Playground.AssistActionPill) => void
}

const ChatFrame = styled(Flex)`
  padding: 6px 22px;
  border-radius: 16px;
  border: 2px solid ${colors.cosmicShade14};
  background-color: ${colors.cosmicShade19};
  overflow-y: auto;
`

const Conversation = (props: ConversationProps) => {
  const { messages, isFetching, maxHeight, minHeight, isLog, handleAssistActionPill } = props

  const { containerRef, lastMessageRef } = useChatAutoScroll({
    messageCount: messages.length,
    isFetching,
    doNotScroll: isLog,
  })

  return (
    <ChatFrame ref={containerRef} flexDirection="column" maxHeight={maxHeight} minHeight={minHeight}>
      {messages.map((message, index) => (
        <Chat
          key={message.id}
          ref={index === messages.length - 1 ? lastMessageRef : undefined}
          message={message}
          isLog={isLog}
          isFetching={isFetching}
          handleAssistActionPill={handleAssistActionPill}
        />
      ))}
      {isFetching ? <LoadingAIBubble /> : null}
    </ChatFrame>
  )
}

Conversation.displayName = 'Conversation'
export default Conversation
